module.exports = __webpack_public_path__ + "static/media/banner-right-03.784dbf84.gif";